export enum DiscountEffectType {
  Percentage = 'pct',
  Flat = 'flat',
}

export enum DiscountSubscriptionType {
  UitPas = 'uitpas',
  IVV = 'ivv',
}

export interface AppliedDiscountSubscription {
  type: DiscountSubscriptionType;
  applicable: true;
  effectAmount: number;
  effectType: DiscountEffectType;
}

export interface InapplicableDiscountSubscription {
  type: DiscountSubscriptionType;
  applicable: false;
}

export type DiscountSubscriptionCheck =
  | AppliedDiscountSubscription
  | InapplicableDiscountSubscription;

// todo: move to its own entity/model
export interface DiscountSubscription {
  type: DiscountSubscriptionType;
  active: boolean;
}

export class UnknownDiscountEffectTypeError extends Error {}
